export default __webpack_public_path__ + "static/media/NoirPro-SemiBold.b6449710.eot";